var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('h2',{staticClass:"main-title"},[_vm._v(_vm._s(_vm.title))]),_c('v-row',[_c('v-col',{attrs:{"cols":"1","md":"2"}},[_c('SideBar')],1),_c('v-col',{attrs:{"cols":"11","md":"10"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }